require('bootstrap')
require('./replacer')
require('./adaptive-placeholder')
require('./certificates-filter')
require('./cp')
require('./lists-load-more')
require('./map')
require('./navbar')
require('./scripts')
require('./scroll-arrow')
require('./scroll-to')
require('./light-gallery')
require('./order')
